<template>
  <div>
    <LittleCard
        v-if="!isLoading"
        variant="warning"
        :text="$t('dashboard.little_cards.resultados_hora')"
        :value="totalResult"
        icon="chart-line"
        class="shadow"
    >
      <template v-slot:top>
        <i class="fas fa-times" @click="$emit('close')"/>
      </template>
    </LittleCard>
    <Loading v-else/>
  </div>
</template>

<script>
import LittleCard from "@/components/LittleCard";
import Loading from "@/components/Loading";
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'ResultPerHour',
  components: {LittleCard, Loading},
  data() {
    return {
      time: ''
    }
  },
  computed: {
    ...mapGetters({
      results: 'ranges/results',
      isLoading: 'ranges/isLoading'
    }),
    totalResult() {
      let total = 0
      if (this.results && this.results.length > 0) {
        this.results.map(r => {
          total += parseInt(r.examsForHour)
        })
      }

      return total;
    }
  },
  methods: {
    ...mapActions([
      'ranges/listVnsReports'
    ]),
  },
  async mounted() {
    await this['ranges/listVnsReports']()
  }
}
</script>

<style lang="scss" scoped>
/deep/ .card-body {
  &:hover {
    .top {
      i {
        visibility: visible;
      }
    }
  }

  .top {
    i {
      cursor: pointer;
      margin-top: -1rem;
      margin-right: -1rem;
      float: right;
      visibility: hidden;
    }
  }
}
</style>
